// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"8676":"7d58a38d","9776":"eb8dbbc9"}[chunkId] + ".chunk.css";
};